import __base_store from '@/store/__base_store'

/**
 * Store de tarjetas de crédito (modelo `credit_card`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'credit_card',
	},
})

